import AppEdgespacersIndex from "./edgeSpacer.vue";
import AppEdgespacersList from "./list/list.vue";
import AppEdgespacersItem from "./item/item.vue";

const routes = [
  {
    path: "/edgeSpacer",
    component: AppEdgespacersIndex,
    meta: {
      auth: {
        roles: "edgeSpacer.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "edgeSpacer.index",
        component: AppEdgespacersList,
        meta: {
          auth: {
            roles: "edgeSpacer.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "edgeSpacer.create",
        component: AppEdgespacersItem,
        meta: {
          auth: {
            roles: "edgeSpacer.create",
            redirect: { name: "edgeSpacer.index" }
          }
        }
      },
      {
        path: ":id",
        name: "edgeSpacer.edit",
        component: AppEdgespacersItem,
        meta: {
          auth: {
            roles: "edgeSpacer.update",
            redirect: { name: "edgeSpacer.index" }
          }
        }
      }
    ]
  }
];

export default routes;
